<template>
    <div>
        <swipeable-cards></swipeable-cards>
    </div>
</template>

<script>
import SwipeableCards from '../components/layout/SwipeableCards.vue'
export default {
  components: {
    SwipeableCards
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  z-index: 0;
}
</style>